import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { useLang } from "@/context/LanguageContext";
import { PageShell, PageHero } from "@/components/layout/PageShell";
import { Button } from "@/components/ui/button";
import { FileText, Download } from "lucide-react";
import DOMPurify from "dompurify";

const mediaUrl = (u) => (u ? (u.startsWith("http") ? u : `${process.env.REACT_APP_BACKEND_URL}${u}`) : "");

export const ContentPage = ({ slug: slugProp }) => {
  const params = useParams();
  const slug = slugProp || params.slug || params.doc;
  const { lang, t } = useLang();
  const [page, setPage] = useState(null);
  const [notFound, setNotFound] = useState(false);

  useEffect(() => {
    setPage(null); setNotFound(false);
    fetch(`${process.env.REACT_APP_BACKEND_URL}/api/pages/${slug}`)
      .then((r) => (r.ok ? r.json() : Promise.reject(r.status)))
      .then((d) => {
        setPage(d);
        if (d.seo_title) document.title = d.seo_title;
        if (d.seo_desc) {
          let m = document.querySelector('meta[name="description"]');
          if (!m) { m = document.createElement("meta"); m.setAttribute("name", "description"); document.head.appendChild(m); }
          m.setAttribute("content", d.seo_desc);
        }
      })
      .catch(() => setNotFound(true));
  }, [slug]);

  const title = page ? (lang === "gu" ? page.title_gu || page.title_en : page.title_en) : "";
  const body = page ? (lang === "gu" ? page.body_gu || page.body_en : page.body_en) : "";
  const pdf = page?.pdf_url;

  return (
    <PageShell>
      <PageHero title={notFound ? "Page not found" : title} />
      <div className="gmoaa-container py-12">
        {notFound ? (
          <p className="text-sm text-gmoaa-text-muted" data-testid="page-not-found">This page is not available.</p>
        ) : !page ? (
          <p className="text-sm text-gmoaa-text-muted">Loading…</p>
        ) : (
          <>
            <div className="gmoaa-prose max-w-3xl text-sm leading-relaxed text-gmoaa-text-dark sm:text-base"
                 data-testid={`page-body-${slug}`} dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(body) }} />
            {pdf && (
              <div className="mt-8 flex max-w-md flex-col items-center gap-4 rounded-2xl border border-dashed border-gmoaa-border-strong bg-white p-8 text-center">
                <span className="flex h-16 w-16 items-center justify-center rounded-full bg-gmoaa-green-light text-gmoaa-green"><FileText size={30} /></span>
                <Button onClick={() => window.open(mediaUrl(pdf), "_blank")} className="bg-gmoaa-green text-white hover:bg-gmoaa-green-hover" data-testid="page-pdf-btn">
                  <Download size={16} className="mr-1.5" /> {t("viewPdf")}
                </Button>
              </div>
            )}
          </>
        )}
      </div>
    </PageShell>
  );
};

export default ContentPage;
